import React, { useEffect, useState } from "react";
import ZohoIntegration from "./ZohoIntegration"; // Import Zoho component
import JiraIntegration from "./JiraIntegration"; // Import Jira component
import { API_BASE_URL } from "../environment";
import { Spinner } from "react-bootstrap";

const TicketingPlatformSelector = () => {
    const [platform, setPlatform] = useState(null); // State to hold the platform name
    const [error, setError] = useState(null); // State to handle errors

    useEffect(() => {
        const fetchPlatform = async () => {
            const apiUrl = `${API_BASE_URL}/wp-json/custom/v1/ticketing-platform-selection`;
            try {
                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        // "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
                    },
                });
                if (!response.ok) {
                    throw new Error(`API Error: ${response.status} ${response.statusText}`);
                }
                const data = await response.json();
                setPlatform(data.value); // Assume the response contains { platform: "zoho" } or { platform: "jira" }
            } catch (err) {
                setError(err.message);
            }
        };

        fetchPlatform();
    }, []);

    if (error) {
        return <p style={{ color: "red" }}>Error: {error}</p>;
    }

    if (!platform) {
        return <p className="text-center pt-5"><Spinner /></p>; // Show a loader while waiting for the API response
    }

    return (
        <div>
            {platform.toLowerCase() === "zoho" ? (
                <ZohoIntegration />
            ) : platform.toLowerCase() === "jira" ? (
                <JiraIntegration />
            ) : (
                <p>Unsupported platform: {platform}</p>
            )}
        </div>
    );
};

export default TicketingPlatformSelector;
